<template>
  <NavigationLayout
    navigationTitle="振込履歴"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div id="payment_histories__wrapper" slot="contents">
      <div id="payment_histories__container">
        <section id="payment_histories__header" v-if="!hasPaymentHistories">
          <p>LIVEポイントの振込履歴はありません</p>
        </section>
        <section
          v-for="(depositHistory, index) in depositHistories"
          :key="`deposit_history_${index}`"
        >
          <ListItem
            title="振込申請日"
            v-bind:actionText="formatDepositDate(depositHistory.deposit_date)"
          />
          <ListItem
            title="申請金額"
            v-bind:actionText="formatDepositValue(depositHistory.value)"
          />
          <ListItem title="振込先" v-bind:style="ListItemStyleSectionLast">
            <div slot="actionInput" class="payment_histories__deposit_to">
              <p>{{ depositHistory.bank_name }}</p>
              <p>支店コード {{ depositHistory.branch_code }}</p>
              <p>
                {{
                  bankAccountTypeForValue(depositHistory.account_type).name
                }}預金{{ depositHistory.account_number }}
              </p>
              <p>{{ depositHistory.account_name }}</p>
            </div>
          </ListItem>
        </section>
        <div>
          <div v-bind:style="CautionsStyle">
            <p>＊1LIVEポイント=1円で換算されます</p>
            <p>＊振込金額は源泉徴収税を引いた額になります</p>
          </div>
        </div>
      </div>
    </div>
  </NavigationLayout>
</template>
<script>
import API from '@/utils/API'
import NavigationLayout from '@/components/NavigationLayout'
import ListItem from '@/components/ListItem'
import MypageStyle from '@/styles/mypage'
import { bankAccountTypeForValue } from '@/utils/MasterBank'
import formatter from '@/utils/Formatter'
export default {
  name: 'payment_histories',
  components: {
    NavigationLayout,
    ListItem,
  },
  data: function () {
    return {
      depositHistories: [],
      CautionsStyle: MypageStyle.Cautions,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
    }
  },
  computed: {
    hasPaymentHistories: function () {
      return this.depositHistories.length > 0
    },
  },
  methods: {
    fetchDepositHistories: async function () {
      const request = API.Request.liveCoinDepositHistoriesGet()
      const response = await API.load(request)
      if (response.LiveCoinDepositHistories) {
        this.depositHistories = response.LiveCoinDepositHistories
      }
    },
    bankAccountTypeForValue: bankAccountTypeForValue,
    formatDepositDate: function (depositDate) {
      return String(depositDate).replace(/-/g, '/')
    },
    formatDepositValue: function (value) {
      return formatter.numberWithCommas(value) + '円'
    },
  },
  mounted() {
    this.fetchDepositHistories()
  },
}
</script>

<style scoped>
#payment_histories__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}

#payment_histories__container {
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-top: 20px;
  padding-bottom: 49px;
}

#payment_histories__header {
  padding: 12px 15px;
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}
section {
  margin-bottom: 20px;
}
.payment_histories__deposit_to {
  line-height: 1.5;
  text-align: right;
}
</style>
